import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import ChapterNavInner from "./ChapterNavInner";
import Chapter from "./components/Chapter";

var ChapterNav = function ChapterNav(_ref) {
  var sticky = _ref.sticky,
      props = _objectWithoutProperties(_ref, ["sticky"]);

  var getClassName = getClassNameFactory("LongformChapterNav");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        sticky: sticky
      })
    })
  }, /*#__PURE__*/React.createElement(ChapterNavInner, props));
};

ChapterNav.displayName = "Longform.ChapterNav";
ChapterNav.propTypes = {
  /**
   * Child nodes. Should be `ChapterNav.Chapter` components.
   */
  children: PropTypes.node.isRequired,

  /**
   * Enable sticky behaviour to make the ChapterNav stick to the top of the screen.
   */
  sticky: PropTypes.bool,

  /**
   * Enable scroll spy to update the current chapter as you scroll the page.
   */
  spy: PropTypes.bool
};
ChapterNav.defaultProps = {
  sticky: true,
  spy: true
};
ChapterNav.Chapter = Chapter;
export default ChapterNav;